import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <nav className="bg-white shadow-sm sticky top-0 z-50" data-id="element-153" data-mp="x9m573ezczun">
      <div className="container mx-auto px-4 py-3 max-w-7xl" data-id="element-154" data-mp="xc011ehhig39">
        <div className="flex justify-between items-center" data-id="element-155" data-mp="sbu69pfx4dgy">
          <div className="flex items-center" data-id="element-156" data-mp="4l8b2yr0inod">
            <Link to="/" className="flex items-center" data-id="element-157" data-mp="4lzulb7c4uya">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/edEruNFEB68kKZjEQhGs49/ChatGPT_Image_Sep_15%2C_2025%2C_01_16_02_PM.png" alt="CalBiome Logo" className="h-10 md:h-12" data-id="element-158" data-mp="jweuadmv477" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8" data-id="element-159" data-mp="1pxrsnxxf52y6">
            <Link to="/about" className="text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-160" data-mp="1q0e0lyo81kgx">
              About
            </Link>
            <Link to="/products" className="text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-161" data-mp="9qk8q1hs94u4">
              Products
            </Link>
            <Link to="/research" className="text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-162" data-mp="jnf44birep46">
              Research
            </Link>
            <Link to="/news" className="text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-163" data-mp="3n574oeayohdz">
              News
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-164" data-mp="ve0ywyyccoy">
              Contact
            </Link>
          </div>
          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-165" data-mp="39bzdgnqslnwt">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-700 hover:text-teal-600 focus:outline-none" data-id="element-166" data-mp="39axp5hkrn4x5">
              {isMenuOpen ? <XIcon size={24} data-id="element-167" data-mp="2wcq3g2orf03a" /> : <MenuIcon size={24} data-id="element-168" data-mp="2wbf36cuiwagx" />}
            </button>
          </div>
        </div>
        {/* Mobile Menu */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4 space-y-4" data-id="element-169" data-mp="3b2xfo0o6bmvj">
            <Link to="/about" className="block text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-170" data-mp="363b1np0iu2lo">
              About
            </Link>
            <Link to="/products" className="block text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-171" data-mp="2dedvgk9l3w9a">
              Products
            </Link>
            <Link to="/research" className="block text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-172" data-mp="2naguvid1xgsj">
              Research
            </Link>
            <Link to="/news" className="block text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-173" data-mp="2k83631k1wso">
              News
            </Link>
            <Link to="/contact" className="block text-gray-700 hover:text-teal-600 transition-colors duration-300" data-id="element-174" data-mp="f4wv9hornpwy">
              Contact
            </Link>
          </div>}
      </div>
    </nav>;
};
export default Navbar;